import useSWRFetcher from "./fetcher";
import settings from "../../../constants/settings";
import useSWRImmutable from "swr/immutable";
import { FlashPCBSettings } from "../../settings";

export const useFlashPCBSettings = () => {
  const fetcher = useSWRFetcher<FlashPCBSettings>();

  const { data } = useSWRImmutable<FlashPCBSettings, Error>(
    `${settings.api_url}/settings`,
    fetcher,
  );

  return data || null;
};
